import { configQuery, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { minLength, required, email } from 'vuelidate/lib/validators';

var KeycloakResetPassword = /** @class */ (function (_super) {
    __extends(KeycloakResetPassword, _super);
    function KeycloakResetPassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.email = '';
        _this.username = '';
        _this.isEmailEnabled = true;
        return _this;
    }
    KeycloakResetPassword.prototype.created = function () {
        this.getIsEmailEnabled();
        this.sendNotification();
    };
    KeycloakResetPassword.prototype.getIsEmailEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            var signupIdField;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, configQuery('signup.signupIdField')];
                    case 1:
                        signupIdField = _a.sent();
                        this.isEmailEnabled = !signupIdField || signupIdField === 'EMAIL';
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(KeycloakResetPassword.prototype, "resetPasswordAction", {
        get: function () {
            return this.kcContext.url.loginAction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KeycloakResetPassword.prototype, "backToLoginUrl", {
        get: function () {
            return window.location.origin + this.kcContext.url.loginRestartFlowUrl;
        },
        enumerable: false,
        configurable: true
    });
    KeycloakResetPassword.prototype.submit = function () {
        if (this.$v.$invalid) {
            return;
        }
        var form = this.$refs['reset-password-form'];
        this.getInput(form, 'username').value = this.isEmailEnabled // we use username name for keycloak to recognise the page
            ? this.email
            : this.username;
        form.submit();
    };
    KeycloakResetPassword.prototype.getInput = function (form, name) {
        return form.elements.namedItem(name);
    };
    KeycloakResetPassword.prototype.sendNotification = function () {
        return this.isEmailEnabled
            ? this.$t('reset-password.message')
            : this.$t('reset-password.username-message');
    };
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], KeycloakResetPassword.prototype, "kcContext", void 0);
    __decorate([
        Emit('notification'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], KeycloakResetPassword.prototype, "sendNotification", null);
    KeycloakResetPassword = __decorate([
        Component({
            name: 'corex-keycloak-reset-password',
            validations: function () {
                var validations = {};
                // Conditional validation for email or username
                if (this.isEmailEnabled) {
                    validations.email = {
                        email: email,
                        required: required,
                    };
                }
                else {
                    validations.username = {
                        minLength: minLength(2),
                        required: required,
                    };
                }
                return validations;
            },
        })
    ], KeycloakResetPassword);
    return KeycloakResetPassword;
}(Mixins(validationMixin, MagicConfigMixin)));

export default KeycloakResetPassword;
